import { Heading } from '@app/app/_components/Heading/Heading';
import { Paragraph } from '@app/app/_components/Paragraph/Paragraph';
import { useAppParameters } from '@app/app/_context/AppParametersContext/useAppParameters';
import { HOME_INSURANCE_STEPS } from '@app/app/esales/home/_sections/steps/HOME_INSURANCE_STEPS';
import { formatEuroValue } from '@app/infrastructure/application/formatEuroValue';
import { FormState } from '@app/lib/form/contracts/FormState';
import { PurchaseHomeInsuranceResult } from '@app/service/eshop/home/actions/purchaseHomeInsurance';
import { useTranslations } from 'next-intl';
import Link from 'next/link';

interface Props {
    formState: FormState<PurchaseHomeInsuranceResult>;
    totalPrice: number;
    currentStepKey: string;
}

export function HomeInsuranceWizardFooter({ formState, totalPrice, currentStepKey }: Props) {
    const { tenant } = useAppParameters();
    const t = useTranslations();
    const parameters = useAppParameters();

    const isPaymentStep =
        currentStepKey === HOME_INSURANCE_STEPS.PAYMENT.OPTIONS ||
        currentStepKey === HOME_INSURANCE_STEPS.PAYMENT.METHOD_TYPE ||
        currentStepKey === HOME_INSURANCE_STEPS.PAYMENT.METHOD;

    return (
        <>
            {totalPrice === 0 ? (
                <div>
                    <div className="text-sm text-neutral-500">{t('eshop.general.selectedInsurance')}</div>
                    <Link
                        target="_blank"
                        href={parameters.eshopHomeInsuranceInfoUrls.readMoreInfo}
                        className="inline-flex items-end justify-start gap-2">
                        <span className="w-min font-medium underline underline-offset-4 sm:w-fit">
                            {t('eshop.home.selectedHome')}
                        </span>
                    </Link>
                </div>
            ) : (
                <div className="flex w-full flex-col md:mr-6 md:flex-row md:items-center md:justify-between">
                    <div className="text-left">
                        <Paragraph isGray size="small" isBold>
                            {isPaymentStep ? t('general.payNow') : t('general.total')}
                        </Paragraph>
                        <Heading className="max-xs:text-lg">
                            {formState.data?.offers && isPaymentStep
                                ? formatEuroValue(formState.data.offers.priceToPayNow ?? 0, tenant)
                                : formatEuroValue(totalPrice, tenant)}
                        </Heading>
                    </div>
                </div>
            )}
        </>
    );
}
